module.exports = __webpack_public_path__ + "static/img/2.3df0b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/2.png
// module id = 5wYT
// module chunks = 0